<ion-header>
  <ion-toolbar>
    <div class="shell-header">
      <a routerLink="/tokens" class="shell-header__brand">
        <span class="shell-header__brand-mark">&gt;_</span>
        Gastro Management <span class="shell-header__brand-sub">Developer</span>
      </a>

      <nav class="shell-header__nav">
        <a routerLink="/tokens" routerLinkActive="active">{{ 'shell.nav.tokens' | translate }}</a>
        <a routerLink="/playground" routerLinkActive="active">{{ 'shell.nav.playground' | translate }}</a>
        <a routerLink="/logs" routerLinkActive="active">{{ 'shell.nav.logs' | translate }}</a>
        <a routerLink="/docs" routerLinkActive="active">{{ 'shell.nav.docs' | translate }}</a>
      </nav>

      <div class="shell-header__right">
        <span class="shell-header__title">{{ title() }}</span>
        <ion-button fill="clear" size="small" class="shell-header__account" [href]="myPreferencesUrl" target="_blank" rel="noopener"
          [attr.aria-label]="'shell.account' | translate" [attr.title]="'shell.account' | translate">
          <ion-icon name="person-circle-outline" slot="icon-only"></ion-icon>
        </ion-button>
        <ion-button fill="clear" size="small" (click)="auth.logout()" [attr.aria-label]="'shell.logout' | translate">
          <ion-icon name="log-out-outline" slot="icon-only"></ion-icon>
        </ion-button>
        <ion-button fill="clear" size="small" class="shell-header__nav-toggle" (click)="toggleNav()"
          [attr.aria-expanded]="navOpen" aria-label="Menu">
          <ion-icon [name]="navOpen ? 'close-outline' : 'menu-outline'" slot="icon-only"></ion-icon>
        </ion-button>
      </div>
    </div>

    @if (navOpen) {
    <nav class="shell-header__nav-panel">
      <a routerLink="/tokens" routerLinkActive="active" (click)="closeNav()">{{ 'shell.nav.tokens' | translate }}</a>
      <a routerLink="/playground" routerLinkActive="active" (click)="closeNav()">{{ 'shell.nav.playground' | translate }}</a>
      <a routerLink="/logs" routerLinkActive="active" (click)="closeNav()">{{ 'shell.nav.logs' | translate }}</a>
      <a routerLink="/docs" routerLinkActive="active" (click)="closeNav()">{{ 'shell.nav.docs' | translate }}</a>
    </nav>
    }
  </ion-toolbar>
</ion-header>
